$ ->

  # making tabs function ---
  # NOTE: some of the selector querying seems to be the "hard way",
  # but this is done intentionally, to ensure that multiple tab
  # UI's work on the same page (everything has to be relative to
  # the tab/link that was clicked)

  $(document).on "click", "[data-tab-trigger]", (e) ->
    e.preventDefault()

    $(this).closest("li").siblings().removeClass("active")
    $(this).closest("li").addClass("active")

    $(this).closest("ul.tabs").find("li").each ->
      trigger = $(this).find("a").data("tab-trigger")
      $("[data-tab-content=" + trigger + "]").hide()

    $tab = $("[data-tab-content=" + $(this).data("tab-trigger") + "]")

    $tab.show()

    $(document).trigger("tab:visible", [$tab, this])

  # similate tab trigger from, for example, a link within a text body
  $(document).on "click", "[data-tab-simulate]", (e) ->
    e.preventDefault()

    # find the "fake" tab we are wanting to click
    simulatedTab = $(this).data("tab-simulate")
    $tabTrigger = $("[data-tab-trigger=" + simulatedTab + "]")

    if ($tabTrigger)
      $tabTrigger.click()